import ACTIONS from "../../constants/actions";

const initialState = {};

export default function videoModal(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.VIDEO_MODAL.UPDATE:
			return action.data;
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/video-modal.js